import {
  SET_TOTAL_UNITS,
  SET_LOADED_UNITS,
  INCREASE_LOADED_UNITS,
  SHOW_LOADER,
  HIDE_LOADER,
  SET_LOADING_MESSAGE,
  SET_PROGRESS_PERCENT,
} from './constants';
import config from '~/config';

export const initialState = {
  totalUnits: 1,
  loadedUnits: 0,
  isVisible: false,
  loadingMessage: '',
  progressPercent: 0,
};

function loaderReducer(state = initialState, action) {
  switch (action.type) {
    case SET_TOTAL_UNITS:
      return {
        ...state,
        totalUnits: action.payload.totalUnits,
      };
    case SET_LOADED_UNITS:
      return { ...state, loadedUnits: action.payload.loadedUnits };
    case INCREASE_LOADED_UNITS:
      return {
        ...state,
        loadedUnits: state.loadedUnits + action.payload.newLoadedUnits,
      };
    case SHOW_LOADER:
      return { ...state, isVisible: true };
    case HIDE_LOADER:
      return { ...state, isVisible: false, loadedUnits: 0 };
    case SET_LOADING_MESSAGE:
      return { ...state, loadingMessage: action.payload.message };
    case SET_PROGRESS_PERCENT:
      return { ...state, progressPercent: action.payload.progressPercent };
    default:
      return state;
  }
}

export default loaderReducer;
